import { createSlice } from '@reduxjs/toolkit';
import { findBundleProduct, patchBundleProduct } from './api';
import { initialState, BundleProduct } from './api/interface';

const normalizeProduct = (product: BundleProduct): BundleProduct => ({
  ...product,
  activeState:
    product.activeState === true || String(product.activeState) === 'true',
  componentsActiveState:
    product.componentsActiveState === true ||
    String(product.componentsActiveState) === 'true',
  variantsActiveState:
    product.variantsActiveState === true ||
    String(product.variantsActiveState) === 'true',
});

const bundleProductSlice = createSlice({
  name: 'bundleProduct',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findBundleProduct.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findBundleProduct.fulfilled, (state, action) => {
      state.data = (action.payload.data || []).map(normalizeProduct);
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findBundleProduct.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(patchBundleProduct.fulfilled, (state, action) => {
      const updated = normalizeProduct(action.payload);
      const index = state.data.findIndex((item) => item.id === updated.id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...updated };
      }
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  bundleProductSlice.actions;
export default bundleProductSlice.reducer;
